import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import ChannelPopup from "./ChannelPopup/ChannelPopup";
import Login from "./LoginScreen/Login";
import Schedule from "./HomeScreenHeader/Schedule/Schedule.jsx";
import PlayList from "./HomeScreenHeader/PlayList/PlayList.jsx";
import Library from "./HomeScreenHeader/Library/Library.jsx";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Report from "./HomeScreenHeader/Reports/Report.jsx";
import AssetRegisterReport from "./HomeScreenDetail/AssetRegisterReport.jsx";
import { SpeedDial } from "primereact/speeddial";
import SliderBar from "./HomeScreenDetail/SliderBar.jsx";
import { throttle } from "lodash"; // Import throttle from lodash
import AdminScreenTabPanel from "./AdminScreenTabPanel/AdminScreenTabPanel.jsx";
import ScheduleInfo from "./HomeScreenDetail/ScheduleInfo.jsx";
import PrivateRoute from "./HomeScreenHeader/HomeHeader/PrivateRoute .jsx";
import AssetLog from "./HomeScreenDetail/AssetLog.jsx";
import { Toaster } from 'react-hot-toast';
import { LoaderProvider } from "./GlobalComponents/Loader.jsx";
function App() {
  const [position, setPosition] = useState({
    top: "calc(60% - 2rem)",
    left: 0,
  });
  const [isSliderBarVisible, setSliderBarVisible] = useState(false);

  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [ScheduleinfoSelectedRowValue, setScheduleinfoSelectedRowValue] =
    useState([]);
  const location = useLocation();
  const speedDialRef = useRef(null);

  const handleUploadClick = () => {
    setSliderBarVisible(true); // Show the SliderBar when the menu item is clicked
  };
  const items = [
    { label: "Upload", icon: "pi pi-upload", command: handleUploadClick },
  ];
  // Throttle to optimize performance
  const handleMouseMove = throttle((e) => {
    if (speedDialRef.current) {
      const buttonSize = 40; // Adjust for button size
      const maxTop = window.innerHeight * 0.4 - buttonSize; // Maximum top position, restricted to bottom 70% of the viewport height

      // Calculate new top position, keeping the right position constant
      const newTop = Math.min(Math.max(e.clientY - buttonSize, 0), maxTop);

      setPosition((prevPosition) => ({
        ...prevPosition,
        top: `${newTop}px`,
      }));
    }
  }, 10); // Adjust the throttle delay as needed

  const handleMouseUp = () => {
    // Clean up the mouse move event listener
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent default behavior for dragging
    // Add event listeners for dragging
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    if (speedDialRef.current) {
      speedDialRef.current.addEventListener("mousedown", handleMouseDown);
    }

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      if (speedDialRef.current) {
        speedDialRef.current.removeEventListener("mousedown", handleMouseDown);
      }
    };
  }, []);
  useEffect(() => {
    if (location.pathname !== "/schedule") {
      setScheduleinfoSelectedRowValue([]); // Clear value when leaving the Schedule page
    }
  }, [location.pathname]);
  const onrowClick = (value) => {
    setScheduleinfoSelectedRowValue(value);
  };

  return (
    <div className="App">
      <LoaderProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/ChannelPopup"
          element={
            <PrivateRoute>
              <ChannelPopup />
            </PrivateRoute>
          }
        />
        <Route
          path="/schedule"
          element={
            <PrivateRoute>
              <Schedule
                ScheduleinfoSelectedRowValue={ScheduleinfoSelectedRowValue}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/playlist"
          element={
            <PrivateRoute>
              <PlayList />
            </PrivateRoute>
          }
        />
        <Route
          path="/library"
          element={
            <PrivateRoute>
              <Library
                setUploadingFiles={setUploadingFiles}
                uploadingFiles={uploadingFiles}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/masterLayout"
          element={
            <PrivateRoute>
              <AdminScreenTabPanel />
            </PrivateRoute>
          }
        />
        <Route
          path="/report"
          element={
            <PrivateRoute>
              <Report />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportTree"
          element={
            <PrivateRoute>
              <AssetRegisterReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/scheduleInfo"
          element={
            <PrivateRoute>
              <ScheduleInfo onrowClick={onrowClick} />
            </PrivateRoute>
          }
        />
        <Route
          path="/assetLog"
          element={
            <PrivateRoute>
             <AssetLog />
            </PrivateRoute>
          }
        />
      </Routes>
      </LoaderProvider>
      {location.pathname !== "/" &&
        location.pathname !== "/login" &&
        location.pathname !== "/ChannelPopup" && (
          <div
            ref={speedDialRef}
            style={{
              position: "absolute",
              top: position.top,
              left: position.left,
              cursor: "move",
            }}
          >
            <SpeedDial
              id="SpeedDial"
              model={items}
              showIcon="pi pi-bars"
              type="semi-circle"
              direction="right"
              style={{ top: position.top, left: position.left }}
            />
          </div>
        )}

      {isSliderBarVisible && (
        <SliderBar
          visible={isSliderBarVisible}
          onHide={() => setSliderBarVisible(false)} // Function to hide the SliderBar
          uploadingFiles={uploadingFiles}
        />
      )}
       <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}
export default App;
